<template>
  <!-- 收入排行榜 -->
  <div class="Ranking">
      <div class="neir" v-for="(item,index) in Topgrossinglist" :key="item.id">
        <img :src="item.headPortrait" width="48px" height="48px">
        <div class="identity-2">
          <p style="color: #38393A;">{{item.userName}}</p>
          <p style="color: #FF2B2B;">￥{{item.income}}</p>
        </div>
      </div>

  </div>
</template>

<script>
 import {Topgrossinglist} from "../../api/projectSquare/xmgc";
  export default {
    data(){
      return {
      Topgrossinglist:[]
      };
    },
    created(){
      this.getlist()
    },
    methods: {
      getlist(){
        Topgrossinglist().then(response => {
          this.Topgrossinglist= response.data
          // console.log(this.Topgrossinglist,"收入排行榜");
        }).catch(response =>{

        })
      },
    },
  }
</script>

<style scoped>
  .Ranking{
    padding-top: 11.125rem;
    position: fixed;
    z-index: 99;
    top: 10.25rem;
    right:3.875rem ;
    width: 15.625rem;
    height: 28rem;
    background:url(../../assets/image/ranking.png)
  }
  .Ranking img{
    border-radius: 50%;

  }
  .neir{
    display: flex;
    margin: 0.3125rem auto;
    width:70%;
    height: 80px;
    /* border: 1px solid red; */
  }
  .identity-2{
    text-align: left;
    margin:auto 0;
  }
  .neir img{
    margin: auto 5px;
  }
  .neir p{
    margin-top: 5px;
    margin-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Topgrossinglist/index.vue